import React, {useContext} from 'react'
import { Modal, Form, Input, Button, message } from 'antd';
import {useFetch} from '../../utils/hooks/useFetch'
import { appContext } from "../../AppContext";
import { InfoCircleOutlined } from '@ant-design/icons';

export default function RegisterModal({isModalVisible, setIsModalVisible}) {

    const [doFetch, FetchOptions] = useFetch();
    // eslint-disable-next-line
    const [appState, AppDispatch] = useContext(appContext);

    function handleOk() {
        // const url = `/api/Account/GetCurrentUser`;

        // doFetch(url)
        //     .then((response) => {
        //         if(response.isSuccess) {
        //             AppDispatch({ type: "LOGIN", payload: response.result })
        //         }
        //         setIsModalVisible(false);
        //     })

        message.success('Please verify your account with the new mail in your inbox (this can take a few minutes to be sent)')
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    function onFinish(values) {
        if(values.password !== values.repeatPassword) {
            message.error('Password is not the same')
            return;
        }

        const body = {
            email : values.userName,
            password : values.password,
            name: values.name
        }

        const url = `/api/Account/Register`;
        doFetch(url, FetchOptions.POST, body, false)
            .then((response) => {
                if(response.result.ok ) {
                    handleOk();
                    return;
                }
                message.error(`Registration failed ${JSON.stringify(response.result.errors)}`, 10, true)
            })

    }

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      };
      const tailLayout = {
        wrapperCol: { offset: 8, span: 16 },
      };

    return (
    <Modal 
        title="Register" 
        visible={isModalVisible} 
        onOk={handleOk} 
        onCancel={handleCancel}
        width={"80%"}                
        footer={null}
    >
          <Form
                {...layout}
                name="basic"
                onFinish={onFinish}
                requiredMark
                >
                <Form.Item
                    label="Email (username)"
                    name="userName"
                    rules={[{ required: true, message: 'Please input your email!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: 'Please input your name!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                    tooltip={{ title: `Password must contain: minimum 8 characters, a digit, a special character, a capital letter  `, icon: <InfoCircleOutlined /> }}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Repeat password"
                    name="repeatPassword"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                    Submit
                    </Button>
                </Form.Item>
            </Form>
    </Modal>
  )
}